/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EffectiveBrandingOutSource = typeof EffectiveBrandingOutSource[keyof typeof EffectiveBrandingOutSource];


export const EffectiveBrandingOutSource = {
  org_branding: 'org_branding',
  arbi_default: 'arbi_default',
} as const;
